export default __webpack_public_path__ + "static/media/hand.e0625766.png";